<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <!-- contactsInformation -->
      <section>
        <fieldset>
          <legend>
            {{ pageVocabs + "legends.contactInfo" | translate }}
          </legend>

          <div class="row">
            <!-- phonebookTitle -->
            <div class="sm:tw-w-1/2">
              <form-field
                [(value)]="phonebookTitle"
                controlName="phonebook"
                [label]="fields + 'phonebookGroup' | translate"
                [isDisabled]="true"
              >
              </form-field>
            </div>
            <!-- firstName -->
            <div class="sm:tw-w-1/2">
              <form-field
                [(value)]="model.firstName"
                [control]="form?.get('firstName')"
                label="common.firstName"
                [maxLength]="32"
              >
              </form-field>
            </div>
            <!--lastName-->
            <div class="sm:tw-w-1/2">
              <form-field
                [(value)]="model.lastName"
                [control]="form?.get('lastName')"
                controlName="lastName"
                label="common.lastName"
                [maxLength]="64"
              >
              </form-field>
            </div>

            <!--cellphone-->
            <div class="sm:tw-w-1/2">
              <form-field
                [(value)]="model.cellPhone"
                [control]="form?.get('cellPhone')"
                [label]="fields + 'cellphone'"
                [maxLength]="14"
                [isLtr]="true"
                classList="dir-ltr"
              >
              </form-field>
            </div>
            <!--telephone-->
            <div class="sm:tw-w-1/2">
              <form-field
                [(value)]="model.telephone"
                [control]="form?.get('telephone')"
                [label]="fields + 'telephone' | translate"
                [minLength]="10"
                [maxLength]="11"
                classNames="dir-ltr"
              >
              </form-field>
            </div>
            <!--email-->
            <div class="sm:tw-w-1/2">
              <form-field
                [(value)]="model.email"
                [control]="form?.get('email')"
                label="common.email"
                [maxLength]="128"
                classList="dir-ltr"
              >
              </form-field>
            </div>
            <!--job-->
            <div class="sm:tw-w-1/2">
              <form-field
                [(value)]="model.job"
                [control]="form?.get('job')"
                [label]="fields + 'job' | translate"
                [maxLength]="64"
              >
              </form-field>
            </div>
            <!--address-->
            <div class="sm:tw-w-1/2">
              <form-textarea
                class="tw-w-full"
                label="common.address"
                [(value)]="model.address"
                [control]="form?.get('address')"
                [rows]="2"
                maxlength="255"
              >
              </form-textarea>
            </div>
            <!--gender-->
            <div class="sm:tw-w-1/2">
              <mat-button-toggle-group
                matInput
                [(ngModel)]="model.gender"
                formControlName="gender"
              >
                <span
                  class="tw-font-medium tw-self-center tw-px-[11px] tw-text-gray-700 dark:tw-text-gray-200"
                  >{{ "common.gender" | translate }}
                  <!-- <span class="tw-mr-[5px] ltr:tw-ml-[5px]">*</span> -->
                </span>
                <!-- male -->
                <mat-button-toggle [value]="genderType.Man">
                  {{ "common.male" | translate }}
                  <mat-icon class="tw-mr-1 dark:tw-text-gray-300">man</mat-icon>
                </mat-button-toggle>
                <!-- female -->
                <mat-button-toggle [value]="genderType.Woman">
                  {{ "common.female" | translate }}
                  <mat-icon class="tw-mr-1 dark:tw-text-gray-300"
                    >woman</mat-icon
                  >
                </mat-button-toggle>
                <!-- unknown -->
                <mat-button-toggle [value]="genderType.All">
                  {{ "common.unknown" | translate }}
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- custom fields -->
      <section
        class="tw-mt-3"
        [class]="input_customFields?.length == 0 ? 'd-none' : ''"
      >
        <details open>
          <summary class="tw-mb-3">
            <span class="tw-text-xl tw-font-semibold">
              {{ "common.customFields" | translate }}
            </span>
          </summary>

          <fieldset>
            <div class="row">
              <!-- custom Fields -->
              <div
                class="sm:tw-w-1/2 tw-flex tw-justify-start tw-items-center"
                *ngFor="let field of customFields; let i = index"
              >
                <!-- Text -->
                <form-field
                  class="tw-w-full"
                  *ngIf="field.fieldType == CustomFieldTypes.String"
                  [(value)]="customFields[i].value"
                  [control]="form?.get('customField-' + field.nameEn)"
                  [label]="field.nameFa | translate"
                >
                </form-field>

                <!--  Integer  -->
                <form-field
                  class="tw-w-full"
                  *ngIf="field.fieldType == CustomFieldTypes.Integer"
                  [(value)]="customFields[i].value"
                  [control]="form?.get('customField-' + field.nameEn)"
                  [label]="field.nameFa | translate"
                  [min]="0"
                  type="tel"
                  [onlyNumbers]="true"
                >
                </form-field>

                <!-- Float -->
                <form-field
                  class="tw-w-full"
                  *ngIf="field.fieldType == CustomFieldTypes.Float"
                  [(value)]="customFields[i].value"
                  [control]="form?.get('customField-' + field.nameEn)"
                  [label]="field.nameFa | translate"
                  [min]="0"
                  type="tel"
                  [onlyNumbers]="true"
                >
                </form-field>

                <!-- Datetime -->
                <datepicker
                  class="tw-w-full"
                  *ngIf="field.fieldType == CustomFieldTypes.Datetime"
                  [value]="customFields[i].value"
                  (value)="customFields[i].value = $event"
                  [control]="form?.get('customField-' + field.nameEn)"
                  [label]="field.nameFa"
                  (onErrorDatePicker)="showErrorDialog($event)"
                >
                </datepicker>

                <!-- Boolean -->
                <div
                  *ngIf="field.fieldType == CustomFieldTypes.Boolean"
                  class="tw-flex tw-justify-start tw-items-center tw-h-full"
                >
                  <mat-slide-toggle
                    [formControlName]="'customField-' + field.nameEn"
                    [(ngModel)]="customFields[i].value"
                  >
                    {{ field.nameFa | translate }}
                  </mat-slide-toggle>
                </div>
              </div>
            </div>

            <!-- <a class="btn btn-sm btn-danger" (click)="log()"> bezan</a> -->
          </fieldset>
        </details>
      </section>

      <section *ngIf="!formPageConfig.isEditMode" class="tw-mt-4">
        <app-delete-contact-by-cellphone
          [model]="model"
          [form]="form"
          (phonebookIdsModel)="deletePhonebookIdsModel = $event"
        >
        </app-delete-contact-by-cellphone>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
